import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { Post, Get } from '@app/utils/httpProvider';
import { GIAYPHEPHANHNGHE_API, ACCOUNTINFO_API, ACCOUNT_API, CHUNGCHI_CHUYENMON_API, DANHSACH_DUYET_HOSO_API } from '@app/utils/apiUrl';
import { messageToast, status200 } from '../../../../utils/define';
import { URI_INTERNAL } from '../../../../utils/pathLocations';
import GiayPhepHanhNgheForm from './GiayPhepHanhNgheForm';
import { getUser } from '@app/utils/oidc';

const TRANG_THAI_CHO_DUYET = "Nhập liệu";

const GiayPhepHanhNgheAdd = () => {
    const history = useHistory();
    const queryClient = useQueryClient();
    const [isLoading, setIsLoading] = useState(false);
    const [accountId, setAccountId] = useState("");
    const [tenDoiTuong, setTenDoiTuong] = useState('');

    // 1. GỌI API LẤY THÔNG TIN ĐỐI TƯỢNG
    //const { data: accountResponse, isLoading: isAccountLoading } = useQuery(['account-info-add'], () => Get(ACCOUNT_API.GET_ACCOUNT_INFO));

    // BÓC TÁCH AN TOÀN


    useEffect(async () => {
        const user = await getUser();
        if (!user?.profile?.sub) return null;
        const accountId = user.profile.sub;
        setAccountId(accountId);

        const accountResponse = await Get(`${ACCOUNT_API.GET_ACCOUNT_INFO_BYID_FROM_APP_DUNGCHUNG}/${accountId}`);
        const tenDoiTuong = accountResponse?.doiTuong?.tenDoiTuong || accountResponse?.data?.doiTuong?.tenDoiTuong || '';
        if (tenDoiTuong) {
            console.log('Đã lấy được tên đối tượng:', tenDoiTuong);
            setTenDoiTuong(tenDoiTuong);
        }
    }, []);

    const addFunc = useMutation((value) =>
        Post(GIAYPHEPHANHNGHE_API.ADD_ITEM, null, value, false)
    );

    const handleCreate = async (values) => {
        setIsLoading(true);
        try {
            // Lấy thông tin user đăng nhập
            const user = await getUser();
            if (!user?.profile?.sub) {
                toast.error('Không lấy được thông tin đăng nhập!');
                setIsLoading(false);
                return;
            }

            // 1. Model cho Giấy phép hành nghề chính
            const model = {
                accountId: user?.profile?.sub,
                loaiGiayPhep: values.loaiGiayPhep,
                noiCap: values.noiCap,
                soGiayPhep: values.soGiayPhep,
                ngayCap: values.ngayCap ? new Date(values.ngayCap).toISOString() : null,
                ngayHetHan: values.ngayHetHan ? new Date(values.ngayHetHan).toISOString() : null,
                trangThai: TRANG_THAI_CHO_DUYET,
                fileMinhChungId: values.fileMinhChungId || null,
                phamViHanhNgheIds: values.phamViHanhNgheIds || []
            };

            // Gọi API Thêm mới Giấy phép
            addFunc.mutate(model, {
                onSuccess: async (res) => {
                    if (res.status !== status200) {
                        toast.error(messageToast.messageToastCreateError);
                        setIsLoading(false);
                    } else {
                        // 1. ĐỌC DỮ LIỆU TỪ RAW RESPONSE
                        const responseData = await res.json();
                        console.log("Dữ liệu sau khi giải nén:", responseData);

                        // 2. Lấy ID an toàn
                        const newGiayPhepId = responseData?.id || responseData?.Id || responseData?.data?.id || responseData?.data?.Id;

                        if (!newGiayPhepId) {
                            console.error("Không tìm thấy ID trong responseData", responseData);
                            toast.error("Không lấy được ID giấy phép để gửi duyệt!");
                            setIsLoading(false);
                            return;
                        }

                        const danhSachChungChi = (values.chungChiChuyenMons || []).filter((item) => {
                            return item && (item.loaiChungChi || item.tenChungChi || item.ngayCap || item.fileMinhChungId || item.fileMinhChungPath || item.ghiChu);
                        });

                        // 3. Gọi API để thêm Chứng chỉ chuyên môn đính kèm
                        if (danhSachChungChi.length > 0) {
                            try {
                                const apiCalls = danhSachChungChi.map((item) => {
                                    const payloadCCCM = {
                                        accountId: user?.profile?.sub,
                                        loaiChungChi: item.loaiChungChi,
                                        tenChungChi: item.tenChungChi,
                                        ghiChu: item.ghiChu || null,
                                        ngayCap: item.ngayCap ? new Date(item.ngayCap).toISOString() : null,
                                        fileMinhChungId: item.fileMinhChungId || null
                                    };
                                    return Post(`${CHUNGCHI_CHUYENMON_API.ADD_ITEM}`, null, payloadCCCM);
                                });
                                await Promise.all(apiCalls);
                            } catch (error) {
                                console.error('Lỗi khi lưu danh sách văn bằng, chứng chỉ chuyên khoa:', error);
                                toast.warning('Thêm giấy phép thành công nhưng lưu văn bằng, chứng chỉ bị lỗi!');
                                setIsLoading(false);
                                return;
                            }
                        }

                        // 4. Gửi duyệt hồ sơ và xử lý chuyển trang + XÓA CACHE CHUẨN XÁC
                        try {
                            const payloadDuyet = {
                                accountId: user?.profile?.sub,
                                giayPhepHanhNgheId: newGiayPhepId,
                            };

                            const resDuyet = await Post(`${DANHSACH_DUYET_HOSO_API.ADD_ITEM}`, null, payloadDuyet);
                            const duyetData = resDuyet?.data || resDuyet;
                            const returnedGiayPhepId = duyetData?.giayPhepHanhNgheId || duyetData?.GiayPhepHanhNgheId;

                            // ==========================================
                            // BƯỚC QUAN TRỌNG: Xóa cache TRƯỚC khi push
                            // ==========================================
                            setIsLoading(false);
                            toast.success(messageToast.messageToastCreateSuccess);

                            // Phải có await ở đây để React Query kịp xóa dữ liệu cũ
                            await queryClient.invalidateQueries(['giayPhepHanhNgheProfile']);

                            // Chuyển trang sau khi đã xóa cache xong
                            history.push({
                                pathname: URI_INTERNAL.GIAYPHEPHANHNGHE_PATH,
                                state: {
                                    newGiayPhepId: returnedGiayPhepId
                                }
                            });

                            return; // Kết thúc tại đây

                        } catch (error) {
                            console.error('Lỗi khi gửi duyệt hồ sơ:', error);
                            toast.warning('Lưu thành công nhưng gửi xét duyệt thất bại!');
                            setIsLoading(false);
                            return;
                        }
                    }
                },
                onError: (err) => {
                    setIsLoading(false);
                    toast.error(err?.message || 'Đã có lỗi xảy ra, vui lòng thử lại !');
                }
            });
        } catch (err) {
            console.error(err);
            toast.error('Có lỗi xảy ra trong quá trình xử lý!');
            setIsLoading(false);
        }
    };

    // if (isAccountLoading) {
    //     return <div className="p-4 text-center">Đang tải thông tin đối tượng...</div>;
    // }

    return (
        <GiayPhepHanhNgheForm
            title="Thêm mới"
            submitText="Lưu thông tin"
            initialValues={{
                loaiGiayPhep: '',
                noiCap: '',
                soGiayPhep: '',
                ngayCap: '',
                ngayHetHan: '',
                phamViHanhNgheIds: [],
                fileMinhChungId: '',
                fileMinhChungPath: '',
                fileMinhChungName: '',
                chungChiChuyenMons: []
            }}
            onSubmit={handleCreate}
            onCancel={() => history.push(URI_INTERNAL.GIAYPHEPHANHNGHE_PATH)}
            isSubmitting={isLoading}
            tenDoiTuong={tenDoiTuong}
        />
    );
};

export default GiayPhepHanhNgheAdd;